import React from 'react';
import HomeDesktopActivitiesCards from './HomeDesktopActivitiesCards';
import HomeMobileActivitiesCards from './HomeMobileActivitiesCards';

export default function HomeActivitiesCards({ data }) {
  return (
    <section className="lg:-mt-[80px] -mt-[20px] relative overflow-hidden">
      <HomeDesktopActivitiesCards data={data} />
      <HomeMobileActivitiesCards data={data} />
    </section>
  );
}
